module.exports = __webpack_public_path__ + "static/media/cruise-med-large2.a6c47651.jpg";